import React from 'react'
import { useHistory } from 'react-router-dom'
import AppRoutes from '../../routes/appRoutes'
import LogoHeader from '../login/includes/LogoHeader'
import CardInfo from '../CardInfo/CardInfo'
import Button from '../Button/Button'
import ContentLayout from '../ContentLayout/ContentLayout'

const NoMatch = () => {
    const { push } = useHistory()

    return (
        <div>
            <LogoHeader />
            <ContentLayout>
                <div className="md:w-128 w-full h-auto lg:pb-0 p-8 pb-0">
                    <CardInfo
                        title="404"
                        subTitle="Page not found"
                        content={
                            <Button
                                variant="primary"
                                className="w-60 lg:h-auto h-10"
                                text="Return Home"
                                type="button"
                                onClick={() => push(AppRoutes.login())}
                            />
                        }
                    />
                </div>
            </ContentLayout>
        </div>
    )
}

export default NoMatch
